import { textHelper } from '@guuru/helpers-common';

const regExpValidator = (_, value) => (textHelper.isValidRegExp(value)
  ? Promise.resolve()
  : Promise.reject(new Error('Invalid Pattern'))
);

// eslint-disable-next-line import/prefer-default-export
export { regExpValidator };
